export interface InstagramPost {
  id: string;
  caption?: string;
  media_type: 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM';
  media_url: string;
  permalink: string;
  thumbnail_url?: string;
  timestamp: string;
  username?: string;
}

export interface InstagramApiResponse {
  data: InstagramPost[];
  paging?: {
    cursors: {
      before: string;
      after: string;
    };
    next?: string;
  };
}

export class InstagramService {
  private baseURL = '/.netlify/functions';

  /**
   * Fetch the latest posts from Instagram via Netlify function
   * @param limit Number of posts to fetch (default: 6)
   * @returns Array of Instagram posts
   */
  async getLatestPosts(limit: number = 6): Promise<InstagramPost[]> {
    try {
      const url = `${this.baseURL}/instagram?limit=${limit}`;
      const response = await fetch(url);

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Instagram API error:', errorData);
        throw new Error(`Instagram API error: ${errorData.error || response.statusText}`);
      }

      const data: InstagramApiResponse = await response.json();
      return data.data || [];
    } catch (error) {
      console.error('Failed to fetch Instagram posts:', error);
      throw error;
    }
  }

  /**
   * Check if the service is properly configured
   * In production, this is always true since credentials are server-side
   */
  isConfigured(): boolean {
    // In production (Netlify), credentials are always configured server-side
    // In development, we can check if the function endpoint is available
    return true;
  }

  /**
   * Get Instagram profile URL
   */
  getProfileUrl(username: string = 'lulaendocomunidad'): string {
    return `https://www.instagram.com/${username}`;
  }
}

// Export a singleton instance
export const instagramService = new InstagramService();



